import {useState, useEffect} from 'react';
import api from '../../api';


export const useFattyAcidDetail = ({ job, token }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    console.log('Querying /result/fatty-acid-contribution')
    console.debug(job)
    if ((job.status === 'queued') || (job.status === 'pending')) {
      console.debug("returning early because job is not ready")
      return
    }
    const fetchJson = async () => {
      await api.get(
        'result/fatty-acid-contribution', {
          params: {
            job_id: job.id
          },
          headers: {
            authorization: token
          },
        }
      ).then(
        response => setData(JSON.parse(response.data))
       ).catch(
        error => {
          if (error.response.status === 408) {
            setData(null)
            return
          }
        }
      );
    }
    fetchJson();
  }, [job, token]);
  return data;
}


